var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddReaction = function SvgAddReaction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15a7.5 7.5 0 1 1 7.35-5.996A3 3 0 0 0 12 12a3 3 0 0 0-2.996 2.85c-.486.098-.989.15-1.504.15Zm2.917-9.167a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5ZM7.5 12.5c-1.841 0-3.333-1.866-3.333-4.167h6.666c0 2.301-1.492 4.167-3.333 4.167ZM3.333 4.583a1.25 1.25 0 1 0 2.5 0 1.25 1.25 0 0 0-2.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.006 11a1 1 0 0 0-1 1v2h-2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1Z"
  })));
};
export default SvgAddReaction;